import { useCallback } from 'react';
import { IconButton } from '@hotjar/hotsauce';
import { useTranslation } from 'react-i18next';
import { useStore } from '@hotjar/recordings/src/store/player/context';
import { toggleSidePanel } from '@hotjar/recordings/src/features/Playbacks/utils';

export const CloseButton = (): JSX.Element => {
  const { t } = useTranslation();
  const playerStore = useStore();
  const onClick = useCallback(() => toggleSidePanel(playerStore, false), [playerStore]);

  return (
    <IconButton
      size="s"
      icon="close"
      tooltipText={t('common:player.collapse-sidebar')}
      tooltipPlacement="bottom"
      description={t('common:player.collapse-sidebar')}
      kind="ghost"
      onClick={onClick}
    />
  );
};
